<template>
  <div :class="['container',!issue?'pd-70':'']" >
    <div class="topic" v-if="!issue" >
      <!-- 题目 -->
      <el-form ref="form"  :model="form" label-width="0px" label-position="top">
        <div class="topic-item" v-for="(item , indez) in assessFormList" :key="item.name">
          <div class="header">{{ item.name }} </div>

          <div class="item" v-for="(items , index) in item.options" :key="items.key">

            <el-form-item v-if="(!items.RelatedTopics ||  !items.showTp || form[items.show] === items.showTp ) &&  ['单选题'].includes(items.AnswerType)" :label="items.Name"
              :prop="'radio'+ indez + index"
              :rules="[{ required: true, message: '请选择以上选项', trigger: 'change' }]">
              <el-radio-group v-model="form['radio'+ indez + index]" >
                    <el-radio v-for="(itemy,indey) in items.options" :key="indey" class="as-radio" :label="itemy.key" @change="radioChange($event,items)"  :disabled="disable" >
                      {{ itemy.key }}
                      <el-form-item  v-if="itemy.input && form['radio'+ indez + index] === itemy.value"
                              style="display: inline-block"
                              :prop="'radioInput'+ indez + index"
                              :rules="[{ required: true, message: '请填写内容', trigger: 'change' }]">
                          <el-input v-model="form['radioInput'+ indez + index]" size="mini" :disabled="disable" @blur.stop="radioChange($event,items,true)" placeholder="请输入内容"></el-input>
                      </el-form-item>
                  </el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item v-else-if="(!items.RelatedTopics || !items.showTp || form[items.show] === items.showTp ) &&  ['多选题'].includes(items.AnswerType)" :label="items.Name"
              :prop="'checkbox.'+ items.locationIndex"
              :rules="[{ required: true, message: '请选择以上选项', trigger: 'change' }]">
                  <el-checkbox-group   v-model="form.checkbox[items.locationIndex]" @change="chekboxChange($event,items)">
                        <el-checkbox  v-for="(itemy,indey) in items.options" :key="indey" class="as-checkbox"   :label="itemy.key"  :disabled="disable" >
                                {{ itemy.key }}
                                <el-form-item   v-if="itemy.input && form.checkbox[items.locationIndex].includes(itemy.key)"
                                          style="display: inline-block"
                                        :prop="'checkboxInput'+ indez + index"
                                        :rules="[{ required: true, message: '请填写内容', trigger: 'change' }]">
                                      <el-input  :disabled="disable"   v-model="form['checkboxInput'+ indez + index]" size="mini"  @blur="chekboxChange($event,items)"  placeholder="请输入内容"></el-input>
                                  </el-form-item>
                        </el-checkbox>
                  </el-checkbox-group>
            </el-form-item>

            <template  v-else-if="(!items.RelatedTopics || !items.showTp || form[items.show] === items.showTp ) &&  ['多输入题'].includes(items.AnswerType)" >
                    <div class="as-start-name">{{ items.Name }}</div>
                    <el-form-item  v-for="(itemy,indey) in items.options" :key="indey" :label="itemy.key" label-width="2.5rem"
                    :prop="'input' + indez + index + indey"
                    :rules="[{ required: true, message: '请选择以上选项', trigger: 'blur' }]">
                          <el-input  :disabled="disable"   v-model="form['input' + indez + index + indey]" size="mini" placeholder="请输入内容" @blur="inputChange(indez ,index,items)"></el-input>
                    </el-form-item>
              </template>

            <el-form-item v-else-if="(!items.RelatedTopics || !items.showTp || form[items.show] === items.showTp ) && ['主观题'].includes(items.AnswerType)"  :label="items.Name"
                :prop="'area' + indez + index"
              :rules="[{ required: true, message: '请输入', trigger: 'blur' }]">
              <el-input  :disabled="disable"  v-model="form['area' + indez + index]" type="textarea" rows="5" @blur="areaChange($event,items)"/>
            </el-form-item>
          </div>
        </div>
      </el-form>



      <!-- 评估分数 -->
      <div v-if="next" class="topic-item">
        <div class="header">精神状态评估</div>

        <table  class="as-start-table" >
          <tr><td v-for="(item,index) in assessFormList" :key="index" class="as-start-t">{{item.name}}</td></tr>
          <tr><td style="line-height: 1.3;color: #0A0E10;" v-for="(item,index) in assessFormList"  :key="index" class="as-start-b">{{item.value}}</td></tr>
          <tr><td style="line-height: 1.3;color: #0A0E10;" v-for="(item,index) in assessFormList"  :key="index" class="as-start-b">{{item.grade}}</td> </tr>
        </table>

        <el-form :model="form2" ref="form2" label-width="1.5rem"  :inline="true">
            <table border="1" class="table-grade" v-if="detail.type === '老年人能力评估'" >
                 <tr>
                    <td class="as-start-b" style="width:0.5rem" >等级变更条款</td>
                    <td class="as-start-b" style="padding-bottom: 0.5rem" :colspan="assessFormList.length - 1">
                        <el-form-item label="总分"  prop="levelChange" :rules="[{ required: true, message: '请选择以上选项', trigger: 'change' }]">
                              <el-radio-group v-model="form2.levelChange" style="width: 100%" >
                                     <el-radio class="as-radio"  :label="0">0无</el-radio>
                                      <el-radio class="as-radio"  :label="1">有认知障碍/痴呆者，在原有能力级别上提高一个等级</el-radio>
                                      <el-radio  class="as-radio"  :label="2">2近30天内发生过2次及以上跌倒、噎食、自杀、走失者，或在跌倒风险评估中评为“高度风险”的，在原有能力级别上提高一个等级</el-radio>
                                     <el-radio class="as-radio"  :label="3">3处于昏迷状态者，直接评定为重度失能</el-radio>
                                   <el-radio class="as-radio"  :label="4">若初步等级确定为“3重度失能”，则不考虑上述1-3中各情况对最终等级的影响，等级不再提高</el-radio>
                              </el-radio-group>
                         </el-form-item>
                    </td>
                </tr>
            </table>

            <template v-if="detail.type === '老年人能力评估'">
                <table class="as-card-table" border="1" cellpadding="0" cellspacing="1" >
                    <thead>
                      <tr style="background: #FBFCFE">
                          <td colspan="17" >结果判定卡</td>
                      </tr>
                      <tr  style="background: #FBFCFE">
                          <td rowspan="2" colspan="3"  class="w10"  >能力等级</td>
                          <td rowspan="2" colspan="2" >日常生活活动</td>
                          <td colspan="4" >精神状态</td>
                          <td colspan="4" >感知觉与沟通</td>
                          <td colspan="4" >社会参与</td>
                      </tr>
                      <tr style="background: #FBFCFE">
                          <td >0</td>
                          <td >1</td>
                          <td >2</td>
                          <td >3</td>
                          <td >0</td>
                          <td >1</td>
                          <td >2</td>
                          <td >3</td>
                          <td >0</td>
                          <td >1</td>
                          <td >2</td>
                          <td >3</td>
                      </tr>
                    </thead>
                        <tbody>
                            <tr>
                              <td class="w10" rowspan="4" colspan="3" :class="[cardValue0 === 0?'check-grade':'']">0能力完好</td>
                              <td  v-for="(item , index) in 14" :class="[cardValue0 === 0 && cardValue1 ===0 && ([3+cardValue2,7+cardValue3,11+cardValue4].includes(item) || item === 2) ?'check-grade':'']" :style="{'background':[2,3,7,11,12].includes(item)?'#B19476': ''}" :key="index">{{item == 1 ? '0' : ''}}</td>
                            </tr>
                            <tr>
                                <td :class="[cardValue0 === 0 && cardValue1 ===1 && ([3+cardValue2,7+cardValue3,11+cardValue4].includes(item) || item === 2)?'check-grade':'']"  v-for="(item,index) in 14" :key="index">{{item == 1 ? '1' : ''}}</td>
                            </tr>
                            <tr>
                                <td :class="[cardValue0 === 0 && cardValue1 ===2 && ([3+cardValue2,7+cardValue3,11+cardValue4].includes(item) || item === 2) ?'check-grade':'']"  v-for="(item,index) in 14" :key="index">{{item == 1 ? '2' : ''}}</td>
                            </tr>
                            <tr>
                                <td :class="[cardValue0 === 0 && cardValue1 ===3 && ([3+cardValue2,7+cardValue3,11+cardValue4].includes(item) || item === 2) ?'check-grade':'']"  v-for="(item,index) in 14" :key="index">{{item == 1 ? '3' : ''}}</td>
                            </tr>


                            <tr>
                                <td  class="w10" rowspan="4" colspan="3"  :class="[cardValue0 === 1?'check-grade':'']">1轻度失能</td>
                                <td  v-for="(item,index) in 14" :class="[cardValue0 === 1 && cardValue1 === 0 && ([3+cardValue2,7+cardValue3,11+cardValue4].includes(item) || item === 2)?'check-mark':'']" :style="{'background':[2,4,5,6,8,9,10,13,14].includes(item)?'#9B6A5C': ''}" :key="index">{{item == 1 ? '0' : ''}}</td>
                            </tr>
                            <tr>
                                <td  v-for="(item,index) in 14"  :class="[cardValue0 === 1 && cardValue1 ===1 && ([3+cardValue2,7+cardValue3,11+cardValue4].includes(item) || item === 2)?'check-mark':'']"  :style="{'background':[2,3,4,7,8,10,11,12].includes(item)?'#8097A5': ''}" :key="index">{{item == 1 ? '1' : ''}}</td>
                            </tr>
                            <tr>
                                <td  v-for="(item,index) in 14"  :class="[cardValue0 === 1 && cardValue1 ===2 && ([3+cardValue2,7+cardValue3,11+cardValue4].includes(item) || item === 2)?'check-mark':'']" :key="index">{{item == 1 ? '2' : ''}}</td>
                            </tr>
                            <tr>
                                <td  v-for="(item,index) in 14"  :class="[cardValue0 === 1 && cardValue1 ===3 && ([3+cardValue2,7+cardValue3,11+cardValue4].includes(item) || item === 2)?'check-mark':'']" :key="index" >{{item == 1 ? '3' : ''}}</td>
                            </tr>

                            <tr>
                                <td  class="w10" rowspan="4" colspan="3" :class="[cardValue0 === 2?'check-grade':'']">2中度失能</td>
                                <td  v-for="(item,index) in 13" :class="[cardValue0 === 2 && cardValue1 === 0 &&([3+cardValue2,7+cardValue3,11+cardValue4].includes(item) || item === 2)?'check-mark':'']" :key="index">{{item == 1 ? '0' : ''}}</td>
                            </tr>
                            <tr>
                                <td  v-for="(item,index) in 14" :class="[cardValue0 === 2 && cardValue1 === 1 && ([3+cardValue2,7+cardValue3,11+cardValue4].includes(item) || item === 2)?'check-mark':'']" :style="{'background':[2,5,6,8,9,10,13,14].includes(item)?'#375289': ''}" :key="index">{{item == 1 ? '1' : ''}}</td>
                            </tr>
                            <tr>
                                  <td  v-for="(item,index) in 14"  :class="[cardValue0 === 2 && cardValue1 === 2 && ([3+cardValue2,7+cardValue3,11+cardValue4].includes(item) || item === 2)?'check-mark':'']" :style="{'background':[2,3,4,5,7,8,9,11,,12,12,13].includes(item)?'#375289': ''}" :key="index">{{item == 1 ? '2' : ''}}</td>
                            </tr>
                            <tr>
                                <td  v-for="(item,index) in 14" :class="[cardValue0 === 2 && cardValue1 === 3 &&([3+cardValue2,7+cardValue3,11+cardValue4].includes(item) || item === 2)?'check-mark':'']" :key="index">{{item == 1 ? '3' : ''}}</td>
                            </tr>

                            <tr>
                                <td  class="w10" rowspan="4" colspan="3" :class="[cardValue0 === 3?'check-grade':'']">3重度失能</td>
                                <td  v-for="(item,index) in 13" :class="[cardValue0 === 3 && cardValue1 === 0 && ([3+cardValue2,7+cardValue3,11+cardValue4].includes(item) || item === 1)?'check-mark':'']" :key="index">{{item == 1 ? '0' : ''}}</td>
                            </tr>
                            <tr>
                              <td  v-for="(item,index) in 14" :class="[cardValue0 === 3 && cardValue1 === 1 &&([3+cardValue2,7+cardValue3,11+cardValue4].includes(item) || item === 2)?'check-mark':'']" :key="index">{{item == 1 ? '1' : ''}}</td>
                            </tr>
                            <tr>
                                <td  v-for="(item,index) in 14" :class="[cardValue0 === 3 && cardValue1 === 2 &&([3+cardValue2,7+cardValue3,11+cardValue4].includes(item) || item === 2)?'check-mark':'']" :style="{'background':[2,5,6,9,10,13,14].includes(item)?'#737373': ''}" :key="index">{{item == 1 ? '2' : ''}}</td>
                            </tr>
                            <tr>
                                  <td  v-for="(item,index) in 14" :class="[cardValue0 === 3 && cardValue1 === 3 && ([3+cardValue2,7+cardValue3,11+cardValue4].includes(item) || item === 2)?'check-mark':'']" :style="{'background':![1].includes(item)?'#737373': ''}" :key="index">{{item == 1 ? '3' : ''}}</td>
                            </tr>
                        </tbody>
                </table>

                <div class="as-result-hint">
                    <ul>
                        <li class="as-result-hint-content">
                            <span class="as-result-waring-img">!</span>
                            <span style="color: black;">注∶使用结果判定卡时，一般根据日常生活活动进行初步定为，锁定目标区域，然后根据其他三项能力，在判定卡上同一颜色区域定为查找相应的能力等级，以下为几种特殊情况:</span>
                        </li >
                         <li  class="as-result-hint-content"><span>(1)</span>当日常生活活动为0，精神状态、感知觉与沟通有一项为1及以上，或社会参与为2，判定为轻度失能; </li>
                         <li  class="as-result-hint-content"><span>(2)</span>当日常生活活动为1，后三项有一项为0或1，判定为轻度失能，后三项均为2或某一项为3，则判定为中度失能; </li>
                         <li  class="as-result-hint-content"><span>(3)</span>当日常生活活动能力为2，后三项全部为2或某一项为3，判定为重度失能，否则为中度失能。 </li>
                    </ul>
                </div>
            </template>



            <div class="pd">
              <el-form-item  style="width:45%"  label="总分"  prop="value"  :rules="[{ required: true, message: '请选择以上选项', trigger: 'change' }]" >
                  <el-input v-model="form2.value" placeholder="0" disabled></el-input>
              </el-form-item>

              <el-form-item  style="width:45%;float:right" label="等级"  prop="levelid"  :rules="[{ required: true, message: '请选择以上选项', trigger: 'change' }]">
                  <el-select v-model="form2.levelid" placeholder="请选择"  >
                      <el-option v-for="item in assessmentGrade" :key="item.Value" :label="item.Text" :value="item.Value"> </el-option>
                    </el-select>
              </el-form-item>

              <el-form-item style="width: 100%" label="说明"   prop="remark" :rules="[{ required: true, message: '请填写内容', trigger: 'blur' }]">
                  <el-input v-model="form2.remark"  :rows="4" type="textarea" style="width: 100%" />
              </el-form-item>
            </div>
        </el-form>

        <!-- 签名 -->
        <el-row :gutter="20" class="signature" >
          <el-col class="signature-type">家属签名</el-col>
          <el-col >
            <img v-if="img1" class="as-img-signature" :src="img1" @click="dialogVisible = true" >
            <div v-else class="signature-placeholder"  @click="openSignature('1')"> 点击签名</div>
          </el-col>
          <el-col  class="signature-type">评估签名</el-col>
          <el-col >
            <img v-if="img2" class="as-img-signature" :src="img2" @click="dialogVisible = true" >
            <div v-else class="signature-placeholder"  @click="openSignature('0')"> 点击签名</div>
          </el-col>
        </el-row>
      </div>

           <!-- 按钮 -->
      <div class="btn">
        <div v-if="next" class="save" v-loading="loading3" @click="submitAssess">发布</div>
        <template v-else>
          <div class="pauseSave" v-loading="loading2" @click="workingAssess">暂存</div>
          <div class="save"  v-loading="loading3" @click="saveAssess">保存</div>
        </template>
      </div>
    </div>

    <div  v-else class="success">
        <div class="success-img">
          <img class="img" :src="require('@/assets/imgs/zhengque.png').default" alt="">
          <span>发布成功</span>
        </div>
        <div class="success-btn">
            <div class="go-back" @click="$router.go(-1)">返回列表</div>
            <div class="look-as" @click="loockReport">查看报告</div>
        </div>
    </div>


    <!-- 签字板弹框 -->
    <el-dialog
        class="as-signature"
        :visible.sync="dialogVisible"
        width="100%"
        :show-close="false"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        center>
      <div>
          <div class="as-signature-content">
            <div :class="activeSignature === '0' ? 'active-signature':''"  @click="activeSignature = '1'">家属签名</div>
            <div :class="activeSignature === '1' ? 'active-signature':''"  @click="activeSignature = '0'">评估人签名</div>
            <i class="el-icon-delete-solid clear-signature" @click="clearSignature"></i>
          </div>
          <Signature ref="canvasName1" v-show="activeSignature === '1'" width="100%" height="6rem" canvas-name="canvasName1" :img.sync="img1"/>
          <Signature ref="canvasName2" v-show="activeSignature === '0'" width="100%" height="6rem" canvas-name="canvasName2" :img.sync="img2"/>
      </div>
      <div slot="footer" class="dialog-footer" style="display:flex ; justify-content: flex-end;">
        <div class="cancel-signature" @click="cancelSignature">取 消</div>
        <div class="confirm-signature" v-loading="loading"  @click="confirmSignature">确 定</div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Signature from "./signature.vue";
export default {
  components:{
    Signature
  },
  data(){
    return {
      loading:false,
      loading2:false,
      loading3:false,
      disable:false,
      next:false,
      issue:false,
      dialogVisible:false,
      assessFormList:[],
      assessmentGrade:[],
      assessResult:[],
      clearAssess:[],
      form:{checkbox:[]},
      form2: {
          value: '',
          levelChange: '',
          levelid: ''
      },
      cardValue0: '',
      cardValue1: '',
      cardValue2: '',
      cardValue3: '',
      cardValue4: '',
      img1: "",
      img2: "",
      activeSignature: "",
    }
  },
  created(){
    this.getData(this.$route.query)
  },
  methods:{
    //去评估
    getData(val) {
      this.detail = val
      this.evalTypeid = val.evaTypeid
      this.mbrCardNo = val.mbrCardNo
      this.id = val.id
      this.$axios.get(`/Evaluate/GetSubjectMessage?evalTypeId=${val.id}`).then((response) => {
            const res = response.data
            //生成小类型需要的数据结构
              res.obj.model.forEach((el, index) => {
                  if (["单选题", "多选题", "多输入题"].includes(el.AnswerType)) {
                      el.options = []
                      let key = el.Option.trim().split(/\s+/)
                      let value = el.OptionValue && el.OptionValue.trim().split(',') || []
                      key.forEach((item, indey) => {
                          //处理关联类型
                          if (/【关联】/.test(item)) {
                              el.options[indey] = {
                                  key: item.replace('【关联】', ''),
                                  value: value[indey] || '',
                                  isRelation:true
                              }
                          } else if (/【】/.test(item)) {
                              //处理带输入框
                              el.options[indey] = {
                                  key: item.replace('【】', ''),
                                  value: value[indey] || '',
                                  input: true
                              }
                          } else {
                              //处理不带输入框
                              el.options[indey] = {
                                  key: item,
                                  value: value[indey] || '',
                              }
                          }
                      })
                  }
                  //处理关联
              })
              //分大类型
              let data = res.obj.Type1.map(el => {
                  return {
                      name: el,
                      options: res.obj.model.filter(item => item.Type1 === el),
                      value: 0,
                      grade: '',
                  }
              })

              let locationIndex = 0
              let form = {}
              //初始化和回选
              data.forEach((val, index) => {
                  if (val.options instanceof Array) {
                      //初始化多选默认值，不然会报错
                      val.options.forEach((el, indey) => {
                          el.index = index
                          el.indey = indey
                          if (["多选题"].includes(el.AnswerType)) {
                              this.$set(this.form.checkbox, locationIndex, [])
                              el.locationIndex = locationIndex
                              locationIndex++
                          }

                          // 处理关联
                          if (el.RelatedTopics) {
                            res.obj.model.forEach((item) => {
                              if (el.RelatedTopics === item.Id ) {
                                  item.relevanceId = el.Id //关联的id,用于清除关联题目的分数
                                  el.show = 'radio' + item.index + item.indey
                                  let tip =  item.options.find( i => i.isRelation)
                                  el.showTp = tip && tip.key ||  '' //防止没设置关联
                              }
                            })
                          }

                          //回选
                          if (el.Answer) {

                              if (["多选题"].includes(el.AnswerType)) {
                                  el.Value = 0
                                  let backValue = []
                                  el.options.forEach(item => {
                                      if (el.Answer.includes(item.key)) {
                                          backValue.push(item.key)
                                          el.Value += item.value
                                      }
                                  })
                                  this.$set(this.form.checkbox, locationIndex, backValue)
                                  this.chekboxChange(backValue, el)
                                  el.locationIndex = locationIndex
                                  locationIndex++
                                  if (el.AnswerRemark) {
                                      this.$set(this.form, 'checkboxInput' + index + indey, el.AnswerRemark)
                                      this.chekboxChange(el.AnswerRemark, el)
                                  }
                              } else if (["单选题"].includes(el.AnswerType)) {
                                  let backValue = el.options.find(item => item.key === el.Answer).key
                                  el.Value = backValue
                                  this.$set(this.form, 'radio' + index + indey, backValue)
                                  this.radioChange(backValue, el)
                                  if (el.AnswerRemark) {
                                      this.$set(this.form, 'radioInput' + index + indey, el.AnswerRemark)
                                      this.radioChange(el.AnswerRemark, el,true)
                                  }
                              } else if (["多输入题"].includes(el.AnswerType)) {
                                  let value = el.Answer.split(",")
                                  el.options.forEach((item, indez) => {
                                      this.$set(this.form, 'input' + index + indey + indez, value[indez])
                                      this.inputChange(index, indey, el)
                                  })
                              } else {
                                  this.$set(this.form, 'area' + index + indey, el.Answer)
                                  this.areaChange(el.Answer, el)
                              }

                          }
                      })
                  }
              })

              this.assessFormList = data
              if (this.detail.status === '待评估') {
                  this.next = true
                  this.getGrade()
              }

      })

      this.$axios.get(`/Evaluate/ListlevelidSource?evatypeid=${val.evaTypeid}`).then((res) => {
        this.assessmentGrade = res.data.obj;
      })

    },

    //多选表单
    chekboxChange(val1, val2) {
        if (val1 instanceof Array) {
            const vlaue = val1.map(el => val2.options.find(item => item.key === el).value)
            val2.Value = 0
            vlaue.forEach(el => val2.Value += Number(el))
            let result = {
                EvaListid: val2.Id,
                evaTypeid: this.evalTypeid,
                Value: vlaue.join(','),//选中的分数，单选是一个，多选用, 分割, 主观题无
                Answer: val1.join(',') ,//答案 单选取选择的答案名称，多选取答案名称+, 拼接，主观题直接输入的答案,
                mbrCardNo: this.mbrCardNo,
            }
            let index = this.assessResult.findIndex(el => el.EvaListid === val2.Id)
            if (index > -1) {
                this.assessResult[index] = result
            } else {
                this.assessResult.push(result)
            }
        } else {
            this.assessResult.find(el => el.EvaListid === val2.Id).Remark = typeof val1 === 'string' ? val1 : val1.target.value
        }

    },

    //单选表单
    radioChange(val1, val2,isRemark = false) {


      const isRelationValue =  val2.options.find(el => el.key === val1).isRelation
        if (val2.relevanceId && isRelationValue) {
            let index = this.assessResult.findIndex(el => el.EvaListid === val2.relevanceId)
            if (index > -1) this.clearAssess.push(this.assessResult.splice(index, 1)[0])
        } else {
            let index = this.clearAssess.findIndex(el => el.EvaListid === val2.relevanceId)
            if (index > -1) this.assessResult.push(this.clearAssess.splice(index, 1)[0])
        }
        if (!isRemark) {
            val2.Value = val2.options.find(el => el.key === val1).value
            let result = {
                EvaListid: val2.Id,
                evaTypeid: this.evalTypeid,
                Value: val2.Value  ,//选中的分数，单选是一个，多选用, 分割, 主观题无
                Answer: val1,//答案 单选取选择的答案名称，多选取答案名称+, 拼接，主观题直接输入的答案,
                mbrCardNo: this.mbrCardNo,
            }
            let index = this.assessResult.findIndex(el => el.EvaListid === val2.Id)
            if (index > -1) {
                this.assessResult[index] = result
            } else {
                this.assessResult.push(result)
            }

        } else {
            this.assessResult.find(el => el.EvaListid === val2.Id).Remark = typeof val1 === 'string' ? val1 : val1.target.value
        }


    },

    //多输入表单
    inputChange(index, indey, val) {

        let result = {
            EvaListid: val.Id,
            evaTypeid: this.evalTypeid,
            Value: '',//选中的分数，单选是一个，多选用, 分割, 主观题无
            Answer: val.options.map((el, indez) => this.form['input' + index + indey + indez]).join(','),//答案 单选取选择的答案名称，多选取答案名称+, 拼接，主观题直接输入的答案,
            mbrCardNo: this.mbrCardNo,
        }
        let indez = this.assessResult.findIndex(el => el.EvaListid === val.Id)
        if (indez > -1) {
            this.assessResult[indez] = result
        } else {
            this.assessResult.push(result)
        }

    },

    //主观表单
    areaChange(val1, val2) {
        let result = {
            EvaListid: val2.Id,
            evaTypeid: this.evalTypeid,
            Value: '',//选中的分数，单选是一个，多选用, 分割, 主观题无
            Answer: typeof val1 === 'string' ? val1 : val1.target.value,//答案 单选取选择的答案名称，多选取答案名称+, 拼接，主观题直接输入的答案,
            mbrCardNo: this.mbrCardNo,
        }
        let index = this.assessResult.findIndex(el => el.EvaListid === val2.Id)
        if (index > -1) {
            this.assessResult[index] = result
        } else {
            this.assessResult.push(result)
        }
    },



    //暂存评估
    workingAssess(val) {
        if (this.assessResult.length) {
            this.loading2 = true
            let formData = new FormData();
            formData.append('model', JSON.stringify(this.assessResult))
            formData.append('hotelId', localStorage.getItem('comId'))
            formData.append('eid', this.id)
            this.$axios.post(`/Evaluate/SaveStorageEntry`,formData).then((res) => {
                this.loading2 = false
                this.$message.success({
                    message: '暂存成功',
                    offset: 100
                });
            }).catch(() => {
                this.loading2 = false
            })
        } else {
            this.$message.error({
                message: '没有暂存的选项题目',
                offset: 100
            });
        }



    },

    //保存评估
    saveAssess() {
        this.$refs.form.validate((valid) => {
            if (valid) {
                this.loading3 = true
                let formData = new FormData();
                formData.append('model', JSON.stringify(this.assessResult))
                formData.append('hotelId', localStorage.getItem('comId'))
                formData.append('eid', this.id)
                this.$axios.post(`Evaluate/SaveEval`,formData).then((res) => {
                  this.loading3 = false
                   this.getGrade()
                  this.$message.success({
                      message: '保存成功，请完成后面的评估',
                      offset: 100
                  });
               }).catch(() => {
                  this.loading3 = false
               })
            } else {
                this.$message.error({
                    message: '请填写完所有题目',
                    offset: 100
                });
            }
        });
    },

    // 打开签名
    openSignature(val) {
        this.activeSignature = val
        this.dialogVisible = true
    },

    //确认签名
    confirmSignature() {
        this.$refs.canvasName1.saveSign()
        this.$refs.canvasName2.saveSign()
        this.activeSignature = '1'
        this.dialogVisible = false

    },

    //取消签名
    cancelSignature() {
        this.activeSignature = '1'
        this.dialogVisible = false
    },

    //清除签名
    clearSignature() {
        if (this.activeSignature === '0') {
            this.$refs.canvasName2.clearArea()
        } else {
            this.$refs.canvasName1.clearArea()
        }
    },

    //根据评分拿到评估等级
    getGrade() {
        let num = 0
        this.assessFormList.forEach(val => {
            val.value = 0
            val.options.forEach(el => {
                if (el.Value) {
                    num += Number(el.Value)
                    val.value += Number(el.Value)
                }
            })
        })
        //根据总分获取评估等级
        let fn1 = () => this.$axios.get(`/Evaluate/Getlevelid?value=${num}&evatypeId=${this.evalTypeid}`)
        //根据单项评分获取等级
        let formData = new FormData();
        formData.append("list", JSON.stringify(this.assessFormList.map(val => ({ Text: val.name, Sum: val.value }))))
        let fn2 = () => this.$axios.post(`/Evaluate/BigCategory/${this.evalTypeid}`, formData)

        Promise.all([fn1(), fn2()]).then((res) => {
            this.next = true
            this.disable = true
            this.form2.value = num
            this.form2.levelid = res[0].data.obj

            res[1].data.obj.forEach(val => {
                this.assessFormList.forEach(el => {
                    if (el.name === val.Text) el.grade = val.Level
                    if (val.Text.includes('日常生活活动')) this.cardValue1 = val.Level.split('')[0] - 0
                    if (val.Text.includes('精神状态')) this.cardValue2 = val.Level.split('')[0] - 0
                    if (val.Text.includes('感知觉与沟通')) this.cardValue3 = val.Level.split('')[0] - 0
                    if (val.Text.includes('社会参与')) this.cardValue4 = val.Level.split('')[0] - 0
                })
            })
            console.log('1', this.assessFormList);
            if (this.detail.type === '老年人能力评估') {
                switch (this.cardValue1) {
                    case 0:
                        if (this.cardValue2 >= 1 || this.cardValue3 >= 1 || this.cardValue4 === 2) this.cardValue0 = 1
                        break;

                    case 1:
                        if ([0, 1].includes(this.cardValue2) || [0, 1].includes(this.cardValue3) || [0, 1].includes(this.cardValue4)) {
                            this.cardValue0 = 1
                        } else {
                            this.cardValue0 = 2
                        }
                        break;

                    case 2:
                        if ((this.cardValue2 === 3 || this.cardValue3 === 3 || this.cardValue4 === 3) || (this.cardValue2 === 2 && this.cardValue3 === 2 && this.cardValue4 === 2)) {
                            this.cardValue0 = 3
                        } else {
                            this.cardValue0 = 2
                        }
                        break;
                    default:
                        this.cardValue0 = 3
                        break;
                }
                let list = ['能力完好', '轻度失能', '中度失能', '重度失能']
                this.form2.levelid = this.assessmentGrade.find(el => el.Text.includes(list[this.cardValue0])).Value
            }
           this.dialogVisible = false
        }).catch(error => {

            this.loading = false
        })
    },

    //发布
    submitAssess() {
        this.$refs.form2.validate(valid => {
            if (valid) {
                this.$confirm('发布当前评估信息?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let vEvaDetail = []
                    this.assessFormList.map(val => {
                        val.options.forEach(el => {
                            vEvaDetail.push({ "Id1": el.Id, "Value": el.Value })
                        })
                    })

                    let vEvaData = {
                        id: this.id,
                        cuser:this.$store.state.user.UserName,
                        base64string: this.img1,
                        PBase64string: this.img2,
                        vEvaDetail,
                        ...this.form2,
                    }
                    this.loading3 = true

                    this.$axios.post(`/Evaluate/UpdateEva`, vEvaData).then(res => {
                        this.loading3 = false
                        this.issue = true
                    }).catch(()=>{
                      this.loading3=false
                    })

                }).catch(() => {
                    this.loading3 = false
                    return false
                });

            } else {
                this.$message.error({
                    message: '请填写完说明、等级变更条款',
                    offset: 100
                });
            }

        })
    },

    // 查看报告
    loockReport(val){
      this.$router.replace({path:'/assessment/report',query:{id:this.id}})
    }

  }

}
</script>

<style scoped>

.container {
  width: 100%;
  height:100%;
  padding: 12px;
  background: #F7F8FA;
  overflow: hidden;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
}
.pd-70 {
  padding-bottom: 70px;
}
.topic {
  width: 100%;
}

.topic-item {
  width: 100%;
  border-radius: 8px;
  margin-bottom: 12px;
  background: #fff;

}
.topic-item .header {
  padding: 16px 16px 6px 16px;
  border-bottom: 1px solid rgba(2, 159, 209, 0.30);
  font-size: 16px;
  font-weight: bold;
  color: #029FD1;
}

.topic>>> .el-form-item__label{
  display: flex;
  line-height: 2;
  font-size: 16px;
  font-weight: bold;
  color: #333333;
}
.topic  >>> .el-radio__label{
  line-height: 1.2;
  display: inline-block;
  white-space: initial;
  vertical-align: top;
}

.topic-item >>> .el-radio__input.is-checked+.el-radio__label {
  color: #029FD1;
}
.topic-item >>> .el-radio__input.is-checked .el-radio__inner {
  background: #029FD1;
  border-color: #029FD1;
}

.el-form-item {
  margin: 0;
}

.el-radio {
  display: block;
  margin-right: 10px;
}

.as-radio {
  margin-bottom: 10px;
}

.item {
  padding: 16px 16px 16px 16px ;
}


.as-start-table {
    width:100%;
    margin-top:1px;
    text-align: center;
    border-collapse: collapse;
    background: #fff;
    overflow:hidden;
}



.as-start-t {
    padding: 10px;
    vertical-align: middle;
    color: #7C7E80;
    font-size: 0.4rem;
    border: 1px solid #EFEFEFFF;
}

.as-start-b {
    padding: 10px;
    vertical-align: middle;
    color: #7C7E80;
    font-size: 0.4rem;
    border: 1px solid #EFEFEFFF;
}


.table-grade{
    width:100%;
    border-collapse: collapse;
    background: #fff;
    overflow:hidden;
}


.as-card-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  background: #fff;
  color: #0A0E10;
}



.as-card-table thead td {
    color: #7C7E80;
}

.as-card-table tr td {
    position: relative;
        padding: 6px;
    border: 1px solid #EFEFEFFF;
    text-align: center;
    vertical-align: middle;
}

.w10 {
  width: 12px !important;
}


.as-card-table .check-grade {
    background: #FFFE35;
}

.as-card-table .check-mark::before {
    content: "√";
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    color: #0089B5;
}


.as-result-hint {
  padding: 4px;
  line-height:1.2;
  margin-top: 6px;
  font-size: 13px;
  color: #7C7E80;
}

.as-result-hint-content {
    display:flex;
    align-items:flex-start;
}

.as-img-signature {
  width: 100%;
  height: 162px;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
}

.as-result-waring-img {
  flex-shrink: 0;
  width: 14px;
  height: 14px;
  line-height: 14px;
  text-align: center;
  border-radius: 7px;
  margin-right: 2px;
  background: #029FD1;
  color: #fff;
  transform: translate(0,1px);
}


.pd {
  padding: 10px;
}


.pd >>> .el-form-item__content {
  width: 100%;
}


.signature {
  padding: 10px;
}
.signature-type {
  margin: 8px 0;
  font-size: 16px;
  font-weight: 700;
  color: #333333;
}
.signature-placeholder {
  height: 146px;
  padding: 10px 16px;
  border-radius: 4px;
  background: #F8F8F8;
  font-size: 16px;
  color: #9F9FA2;
}



.as-signature  .el-dialog {
    position:relative;
    border-radius: 0.32rem;
    overflow:hidden;
}


.as-signature .el-dialog__body {
  position: relative;
    padding: 0;
}



.as-signature-content {
    position:relative;
    display: flex;
    width: 100%;
    font-size: 0.48rem;
    color: #333333;
    line-height: 0.64rem;
}

.as-signature-content div {
    width: 50%;
    line-height:1.3rem;
    text-align: center;
}


.active-signature {
    background: #DEDFE2;
}




.clear-signature {
    position:absolute;
    bottom:-1.5rem;
    right:0.5rem;
    width: 1rem;
    height: 1rem;
    text-align:center;
    line-height:1rem;
    background: #F2F2F2;
    border-radius: 1rem;
    font-size: 0.5rem;
    color: #029FD1;
}

.cancel-signature {
    width: 48px;
    height: 28px;
    line-height: 28px;
    border: 1px solid #D9D9D9;
    font-size: 14px;
    border-radius: 12px;
    color: #979797;
}

.confirm-signature {
    width: 48px;
    height: 28px;
    line-height: 28px;
    border: 1px solid #D9D9D9;
    border-radius: 12px;
    margin-left: 12px;
    background: #029FD1;
    font-size: 14px;
    color: #fff ;
}


.btn {
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 76px;
  background: #FFFFFF;
  font-size: 16px;
  z-index: 9999;
}
.pauseSave {
  width: 165px;
  height: 44px;
  line-height: 44px;
  text-align: center;
  border-radius: 24px;
  border: 1px solid #029FD1;
  color: #029FD1;
}
.save {
  width: 165px;
  height: 44px;
  line-height: 44px;
  text-align: center;
  border-radius: 24px;
  background: #029FD1;
  color: #fff;
}

.success {
  width: 100%;
  height: 100%;
  padding: 12px;
  background: #FFFFFF;
  border-radius: 8px;
  box-sizing: border-box;
  font-size: 16px;
}

>>> .el-select-dropdown  {
  width: 100%;
}


.success-img {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 50px;

}

.success-img .img{
  width: 66px;
  height: 66px;
  margin-bottom: 13px;
}

.success-btn {
  display: flex;
  justify-content: space-around;
  padding: 0 50px;
  margin-top: 12px;
}

.go-back {
  width: 72px;
  height: 28px;
  text-align: center;
  line-height: 28px;
  border-radius: 14px;
  border: 1px solid #D9D9D9;
  font-size: 14px;
  color: #979797;
}
.look-as {
  width: 72px;
  height: 28px;
  text-align: center;
  line-height: 28px;
  border-radius: 14px;
  background: #029FD1;
  font-size: 14px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/assessment/topic.vue